module.exports = __webpack_public_path__ + "img/19.94e481e8.jpg";